import { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const FixPendingUserEmailModal = ({ show, onHide, currentUser, submitting, onSubmit, serverFieldErrors, onClearServerFieldError }) => {
  const [newEmail, setNewEmail] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (show) {
      setNewEmail("");
      setError("");
    }
  }, [show, currentUser]);

  const emailServerError = serverFieldErrors?.email ?? null;
  const displayError = error || emailServerError;

  const clearErrors = () => {
    setError("");
    if (emailServerError && onClearServerFieldError) {
      onClearServerFieldError("email");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = newEmail.trim();

    if (!trimmed) {
      setError("Enter the corrected email.");
      return;
    }
    if (trimmed.toLowerCase() === (currentUser?.email ?? "").toLowerCase()) {
      setError("Enter an address different from the current one.");
      return;
    }

    onSubmit(trimmed);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Fix email for {currentUser?.full_name}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit} noValidate>
        <Modal.Body>
          <p className="text-muted small mb-3">
            Current email on file: <strong>{currentUser?.email}</strong>. Enter the corrected address below.
            A fresh 6-digit pin will be sent to the new address so the account can be verified.
          </p>
          <Form.Group>
            <Form.Label>New email <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="email"
              value={newEmail}
              onChange={(e) => {
                setNewEmail(e.target.value);
                clearErrors();
              }}
              autoFocus
              maxLength={254}
              isInvalid={!!displayError}
            />
            {displayError && <Form.Control.Feedback type="invalid">{displayError}</Form.Control.Feedback>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="secondary" onClick={onHide} disabled={submitting}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={submitting}>
            {submitting && <Spinner animation="border" size="sm" className="me-2" />}
            Save and resend
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FixPendingUserEmailModal;
